export default __webpack_public_path__ + "static/media/jheel.0cbb98ea.png";